import { useSelector } from "react-redux";

export const useHasRole = (roles = []) => {
  const userRole = useSelector((state) => state.user?.role);

  return roles.includes(userRole);
};
